export const defaultMaginifiedImageStyle = {
  width: '200px',
  height: '200px',
  position: 'absolute',
  backgroundSize: '300%',
  border: '1px solid #ccc',
  zIndex: '9',
  display: 'block',
}

export const getMagnifiedImageStyleConst = {
  width: '200px',
  height: '200px',
  backgroundSize: '300%',
  backgroundPosition: 'center center',
  display: 'block',
}

export const documentPreviewBoxStyle = {
  border: '1px solid #ccc',
  transition: 'background-color 0.3s ease',
}

export const documentPreviewMagnifiedImgStyle = {
  position: 'fixed',
  backgroundSize: '400%',
  border: '2px solid black',
  zIndex: '400',
  display: 'block',
}

export const defaultDocumentPreviewVideoExtList = [
  'mp4',
  'mkv',
  'avi',
  'mov',
  'wmv',
  'flv',
  'webm',
  'm4v',
  '3gp',
  'ogg',
  'ogv',
  'mpeg',
  'mpg',
]

/**
 * Put the default previews here which are not given by the backend and
 * use them to validate from your end the formats of urls you are putting in any
 * template urls !
 */
export const defaultDocumentPreviewAssetUrl = [
  '/assets/images/PDF_THUMB.png',
  '/assets/images/TEXT_logo.png',
  '/assets/images/DOCX_File.png',
  '/assets/images/IMAGE_THUMB.jpg',
  '/assets/images/VIDEO_THUMB.jpeg',
  '/assets/images/CSV-Thumb.png',
  '/assets/images/Excel2007Logo_small.png',
]

export const documentSelectionValidation = 'Please select atleast one file to drag & drop.'

export const statusColorMapper: Record<string, string> = {
  APPROVED: '#9dc2ff',
  REJECTED: '#FECACA',
  PENDING: '#e7e8ea',
}
